import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomizeButton from './ConsentActions/CustomizeButton';
import AcceptAllButton from './ConsentActions/AcceptAllButton';
import RejectAllButton from './ConsentActions/RejectAllButton';
import { vendors } from './iab-tcf';

const useStyles = makeStyles(theme => ({
  screenLink: {
    verticalAlign: 'baseline',
  },
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}));

function ConsentStartScreen({ setActiveScreen, setSelectedCookies, onClose }) {
  const classes = useStyles();

  const openCustomizeScreen = () => {
    setActiveScreen('customize');
  };

  return (
    <Fragment>
      <Box mb={8}>
        <Typography variant="body1" paragraph>
          We and our{' '}
          <Link
            variant="body1"
            className={classes.screenLink}
            component="button"
            type="button"
            onClick={openCustomizeScreen}
            color="primary"
            underline="always"
          >
            {vendors.IAB_SUPPORTED_VENDOR_LIST.length} partners
          </Link>{' '}
          use cookies and other tracking technologies to improve your experience on our website. We may store and/or
          access information on a device and process personal data, such as your IP address and browsing data, for
          personalised advertising and content, advertising and content measurement, audience research and services
          development. Additionally, we may utilize precise geolocation data and identification through device scanning.
        </Typography>
        <Typography variant="body1" paragraph>
          Please note that your consent will be valid across all our subdomains. Once you give consent, a floating
          button will appear at the bottom of your screen, allowing you to change or withdraw your consent at any time.
          We respect your choices and are committed to providing you with a transparent and secure browsing experience.
        </Typography>
      </Box>
      <div className={classes.buttonContainer}>
        <CustomizeButton setActiveScreen={setActiveScreen} />
        <RejectAllButton setSelectedCookies={setSelectedCookies} setActiveScreen={setActiveScreen} onClose={onClose} />
        <AcceptAllButton setSelectedCookies={setSelectedCookies} setActiveScreen={setActiveScreen} onClose={onClose} />
      </div>
    </Fragment>
  );
}

ConsentStartScreen.propTypes = {
  setActiveScreen: PropTypes.func.isRequired,
  setSelectedCookies: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConsentStartScreen;
